<template>
  <div class="cooperativehistory">
    <div class="flex-box">
      <div class="flex-box img-box">
        <img :src="kol_goods.goods_img" />
        <div>
          <el-link class="info treatment"
            type="primary" 
            :underline="false"
            :href="kol_goods.goods_link"
            target='_blank'>{{ kol_goods.goods_name }}</el-link>
          <div class="info">商品ID：{{ kol_goods.goods_id }}</div>
        </div>
      </div>
      <div>
        <div class="info">
          <label>店铺名称：</label>
          <span>【{{ platformObj[kol_goods.platform] }}】<span>{{ kol_goods.store_name }}</span></span>
        </div>
        <div class="info">
          <label>类目：</label>
          <span>
            <span>{{ kol_goods.smzdm_category_1_name ? kol_goods.smzdm_category_1_name : "" }}</span>
            <span v-if="kol_goods.smzdm_category_2_name">/{{ kol_goods.smzdm_category_2_name }}</span>
            <span v-if="kol_goods.smzdm_category_3_name">/{{ kol_goods.smzdm_category_2_name }}</span>
          </span>
        </div>
        <div class="info">
          <label>日常价格：</label>
          <span>¥{{ kol_goods.daily_price }}</span>
        </div>
      </div>
    </div>
    <el-divider class="self-divider"></el-divider>
    <el-table :data="list_data"
      :header-cell-style="{background: '#f9f9f9', color: '#333', fontSize: '14px', fontWeight: 'normal'}"
      :cell-style="{color:'#666', fontSize: '14px'}">
      <el-table-column label="合作商单" width="250">
        <template slot-scope="scope">
          <div>商单编号：{{ scope.row.cpx_order.cxorid }}</div>
          <div>商单标题：{{ scope.row.cpx_order.cpx_order_name }}</div>
        </template>
      </el-table-column>
      <el-table-column label="商品合作价格/佣金">
        <template slot-scope="scope">
          <div>带货商品ID：{{ scope.row.kolgsid }}</div>
          <div>折扣方式：
            <span v-if="scope.row.discount_model == 1">无</span>
            <span v-if="scope.row.discount_model == 2">直降</span>
            <span v-if="scope.row.discount_model == 3">满减</span>
            <span v-if="scope.row.discount_model == 4">优惠券</span>
            <span v-if="scope.row.discount_model == 5">优惠券+满减</span>
          </div>
          <div>优惠后价格：¥{{ scope.row.kol_special_price }}</div>
          <div>提报佣金比例：{{ scope.row.commission_rate }}%</div>
          <div>实际佣金比例：{{ scope.row.settlement_commission_rate }}%</div>
        </template>
      </el-table-column>
      <el-table-column label="时间" width="210">
        <template slot-scope="scope">
          <div>商单预计推广时间：</div>
          <div>{{ scope.row.cpx_order.expect_begin_time.slice(0,10) }} 至 {{ scope.row.cpx_order.expect_end_time.slice(0,10) }}</div>
          <div>商品实际团长时间：</div>
          <div v-if="scope.row.reality_begin_time && scope.row.reality_end_time">{{ scope.row.reality_begin_time.slice(0,10) }} 至 {{ scope.row.reality_end_time.slice(0,10) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.check_status == 1">待审核</div>
          <div v-if="scope.row.check_status == 2">审核通过</div>
          <div v-if="scope.row.check_status == 3">审核不通过</div>
          <div v-if="scope.row.check_status == 4">待回传</div>
          <div v-if="scope.row.check_down == 1" class="p-color-succ">上架</div>
          <div v-if="scope.row.check_down == 2" class="p-color-danger">下架</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <el-button size="medium" type="text" @click="goDetail(scope.row)">查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 页码 -->
    <pagePagination :pageData="pageData" @pageChange="pageChange"></pagePagination>
  </div>
</template>

<script>
import pagePagination from "@/components/page_pagination.vue"
export default {
  name: "cooperativehistory",
  components:{
    pagePagination
  },
  data() {
    return {
      pageData: {
        count: 0,
        page: 1,
        offset: 10
      },
      platformObj: {
        taobao: "淘宝",
        jingdong: "京东",
        tianmao: "天猫",
        suning: "苏宁",
        kaola: "考拉",
        douyin: "抖音小店",
        weipinhui: "唯品会",
        wangyiyanxuan: "网易严选"
      },
      historyData: {},
      kol_goods: {},
      list_data: []
    }
  },
  created() {
    this.historyData.goods_id = this.$route.query.goods_id;
    this.historyData.platform = this.$route.query.platform;
    this.getData();
  },
  methods: {
    getData() {
      this
        .$http({
          method: "GET",
          url: "/home/getCooperationCpxGoodsHistory",
          params: {
            ...this.historyData,
            page: this.pageData.page,
            page_size: this.pageData.offset
          }
        })
        .then(res => {
          if (res.code === 1) {
            this.kol_goods = res.data.kol_goods || {},
            this.list_data = res.data.data || [];
            this.pageData.count = res.data.total || 0;
          } else {
            this.kol_goods = {};
            this.list_data = [];
            this.pageData.page = 1;
            this.pageData.count = 0;
            this.$message.error(res.msg)
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 查看详情
    goDetail(row) {
      this.$router.push({
        path: "/my/cooperativegoods/cooperativehistory/cooperativedetail",
        query: {
          kolgsid: row.kolgsid
        }
      })
    },
    // 分页改变
    pageChange(page, pageSize){
      this.pageData.page = page;
      this.pageData.offset = pageSize;
      this.getData();
    }
  }
}
</script>

<style scoped>
.cooperativehistory {
  color: #333;
  font-size: 14px;
}
.flex-box {
  display: flex;
}
.flex-box img {
  width: 100px;
  height: 100px;
  margin: 8px 14px 0 0;
}
.img-box {
  width: 400px;
  margin-right: 50px;
}
.info {
  line-height: 28px;
}
.info > label {
  display: inline-block;
  width: 120px;
  text-align: right;
}
.self-divider {
  margin: 20px 0;
  background-color: #f4f4f4;
}
.treatment {
  display: -webkit-box;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>